import type { ScreeningReportData } from '@zg-rentals/ts-capps-client';
import type { RetrieveReportsResponse } from '../../models';
import type { UserStatus } from '../../models/rental-application';
import { getIsBackgroundReportExpirationInFuture, getIsCreditReportExpirationInFuture } from '../user-statuses';
import type { FullCreditProfile } from '@zg-rentals/ts-capps-client';

export function getHasNonExpiredReports(userStatuses: Array<UserStatus>) {
  const isBackgroundReportExpirationInFuture = getIsBackgroundReportExpirationInFuture(userStatuses);
  const isCreditReportExpirationInFuture = getIsCreditReportExpirationInFuture(userStatuses);
  return isBackgroundReportExpirationInFuture || isCreditReportExpirationInFuture;
}

export function transformReportData(screeningReportData: ScreeningReportData | undefined): RetrieveReportsResponse {
  if (!screeningReportData) {
    return {
      zipCode: '',
      requiresConditionalApproval: false,
    };
  }

  const creditReport = screeningReportData.creditReport
    ? {
        ...screeningReportData.creditReport,
        fullCreditProfile: screeningReportData.creditReport.fullCreditProfile as unknown as FullCreditProfile,
      }
    : undefined;

  const backgroundReport = screeningReportData.backgroundReport || undefined;

  return {
    creditReport,
    backgroundReport,
    zipCode: screeningReportData.zipCode,
    requiresConditionalApproval: screeningReportData.requiresConditionalApproval,
  };
}
